<div
  *ngIf="submitted || (control.invalid && (control.dirty || control.touched) && errors)"
  class="flex items-start gap-x-1 text-red-400 text-xs">
  <ul class="list-none pl-2">
    <li *ngFor="let key of findKeys(errors)">
      {{ getErrorMessage(key) }}
    </li>
  </ul>
</div>
